import { firebaseMarkerToMarker } from "./markerMapper";

export const firebaseRaceToRace = (firebaseRace: any) => {
  return {
    name: firebaseRace.name,
    createdAt: firebaseRace?.createdAt?.toDate().toString(),
    markerCount: firebaseRace.markers?.length ?? 0,
    isPublic: firebaseRace.isPublic,
    code: firebaseRace.code,
    multilanguages: firebaseRace.multilanguages,
    description: firebaseRace.description,
    image: firebaseRace.image?.uri,
    id: firebaseRace.id,
    markers: firebaseRace.markers.map((marker: any) => {
      return firebaseMarkerToMarker(marker);
    }),
  };
};
